import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import {loadBadges} from "../../actions/AppActions";

class Signature extends Component {
    createSignature = async () => {
        await this.props.dispatch(this.props.EDocPers_CreateSig.execute());
        if (!this.props.EDocPers_CreateSig.isError) {
            await this.props.onRefresh();
            await this.props.dispatch(loadBadges());
        }
    }

    render() {
        return (
            <PlaceholderWrapper placeholderId="10"
                                title={<><i
                                    className="fa fa-file-signature"></i> {i18next.t("Signature_header")}</>}
                                showSplitterLine={false} canCollapse={true}>
                <div>{this.props.message}</div>
                {this.props.isCreateButton === 1 &&
                    <>
                        <br/>
                        <button type="button" className="btn btn-regular -goahead"
                                title={i18next.t("Signature_create")}
                                onClick={this.createSignature}>{i18next.t("Signature_create")}
                        </button>
                    </>
                }
            </PlaceholderWrapper>
        )
    }
}

Signature.propTypes = {
    dispatch: PropTypes.func.isRequired,
    EDocPers_CreateSig: PropTypes.object,
    message: PropTypes.string,
    isCreateButton: PropTypes.number,
    onRefresh: PropTypes.func
}

Signature.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        EDocPers_CreateSig: state.docflowState.EDocPers_CreateSig
    }
}

export default connect(mapStateToProps)(Signature);